import moment from "moment";
import TimeUtils from "utils/time";

export default class Timer {
  constructor(unixTimestamp = null, timezone = null) {
    this.startTime = unixTimestamp
      ? moment.utc(unixTimestamp).utcOffset(0, true)
      : null;
    this.timezone = timezone;
  }

  get elapsed() {
    if (!this.startTime) {
      return 0;
    }
    const localTime = TimeUtils.inThisTimezone(
      this.startTime.format(TimeUtils.FullDateTimeString),
      this.timezone
    );
    const now = moment();
    return Math.abs(now.diff(localTime, "milliseconds"));
  }

  start() {
    this.startTime = moment().utcOffset(0, true);
  }

  stop() {
    this.startTime = null;
  }
}
